import { mount } from 'svelte'
import App from './App.svelte'
import { initAuth } from './auth/keycloak'
import { initFrontendTelemetry, recordClientError } from './telemetry'
import './assets/styles/main.scss'

initFrontendTelemetry()

/* The tender list restores its own scroll position once its data has
   reloaded (see DashboardView's restoreListScroll) — the browser's native
   restore fires on popstate before that async data lands, so left on 'auto'
   it would snap to a too-short page and never retry once content grows. */
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual'
}

const target = document.getElementById('app')
if (!target) {
  throw new Error('Root element #app not found in index.html')
}
const appTarget = target

let app: ReturnType<typeof mount> | undefined

async function bootstrap(): Promise<void> {
  try {
    await initAuth()
    app = mount(App, { target: appTarget })
  } catch (error) {
    recordClientError('bootstrap.authentication_failed', error)
    console.error('Failed to initialize authentication', error)
    appTarget.innerHTML = `
      <div class="bootstrap-error">
        <h1>Authentication failed</h1>
        <p>Argus could not connect to the sign-in service. Please refresh the page.</p>
      </div>
    `
  }
}

void bootstrap()

export default app
